import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetDashboardStats = () => {
  return HTTP_CLIENT.get(Endpoint.dashboard.stats);
};

const GetDashboardGraph = (year?: number) => {
  const currentYear = new Date().getFullYear();
  return HTTP_CLIENT.get(
    Endpoint.dashboard.graph + `?year=${year || currentYear}`
  );
};

export { GetDashboardStats, GetDashboardGraph };
